import api from '../../api';

// initial state
const state = {
    onLoading: true,
    data: [],
    pagination: {
        limit: 5,
        offset: 0,
        total: 0,
        showTotal: (total, range) =>
            `${range[0]}-${range[1]} of ${total} items`,
        showSizeChanger: true,
        pageSizeOptions: ['5', '10', '20'],
        pageSize: 5
    }
};

// getters
const getters = {};

// actions
const actions = {
    index({ commit, state }, query = {}) {
        commit('setOnLoading', true);
        return api
            .membershipIndex({
                offset: state.pagination.offset,
                limit: state.pagination.limit,
                ...query
            })
            .then(res => {
                commit('setOnLoading', false);
                commit('setData', res.data.data);
                commit('setPagination', res.data.meta);
                return res;
            });
    },
    // eslint-disable-next-line
    show({ commit }, id) {
        return api.membershipShow(id);
    },
    // eslint-disable-next-line
    create({ commit }, payload) {
        return api.membershipCreate(payload).then(res => {
            return res;
        });
    },
    update({ commit }, payload) {
        let { id, entity } = payload;
        return api.membershipUpdate(id, entity).then(res => {
            commit('updateDataById', res.data);
            return res;
        });
    },
    delete({ commit }, id) {
        return api.membershipDelete(id).then(res => {
            commit('removeDataById', id);
            return res;
        });
    },
    // meta
    setPagination({ commit }, payload) {
        return new Promise(resolve => {
            commit('setPagination', payload);
            resolve(true);
        });
    }
};

// mutations
const mutations = {
    setData(state, data) {
        state.data = data;
    },
    setOnLoading(state, loadingStatus) {
        state.onLoading = loadingStatus;
    },
    setPagination(state, meta) {
        state.pagination.offset = meta.offset;
        state.pagination.limit = meta.limit;
        state.pagination.total = meta.total;

        state.pagination.pageSize = meta.limit;
    },
    updateDataById(state, data) {
        let index = state.data.indexOf(n => n.id === data.id);
        if (index !== -1) {
            state.data[index] = data;
        }
    },
    removeDataById(state, id) {
        let index = state.data.indexOf(n => n.id === id);
        state.data.splice(index, 1);
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
